/** Presentation of the player being dragged across the Pitch composition. */
import React, { memo } from "react";

import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";

/** Prepared props for the drag overlay presentation. */
export interface WatchlistPitchDragOverlayViewProps {
  readonly playerName: string;
}

/**
 * Renders the compact card that follows the pointer or keyboard cursor.
 * @param props - Accessible label of the lifted player.
 * @param props.playerName - Player name prepared by the container.
 */
const WatchlistPitchDragOverlayView = ({
  playerName,
}: WatchlistPitchDragOverlayViewProps) => (
  <Stack
    testID="watchlist-pitch-drag-overlay"
    direction="horizontal"
    className="items-center rounded-sm border border-outline-default bg-surface-base px-3 py-2 shadow-sm"
  >
    <Text variant="micro" className="text-content-primary">
      Moving {playerName}
    </Text>
  </Stack>
);

WatchlistPitchDragOverlayView.displayName = "WatchlistPitchDragOverlayView";
export default memo(WatchlistPitchDragOverlayView);
